import React from 'react';

const Footer = () => (
  <footer style={{ textAlign: 'center', padding: '2rem', color: 'var(--muted)', fontSize: '0.8rem', position: 'relative', zIndex: 1 }}>
    © 2026 Marion Tamnai Kiterie · Built with React · Nairobi, Kenya
  </footer>
);

export default Footer;